export default "__VITE_ASSET__X1dUkY48__"